module.exports = __webpack_public_path__ + "img/img_kefu@2x.2f918310.png";